import * as Yup from "yup";
import { VALIDATION_ERRORS } from "../../Contract/validation/translations";

Yup.addMethod(Yup.mixed, "validateSelectionFromList", function(list) {
  return this.test(
    "is-selected-from-list",
    VALIDATION_ERRORS.LIST_SELECTION,
    value => list.includes(value)
  );
});
